import { render, staticRenderFns } from "./hebiaojiageshenqing.vue?vue&type=template&id=5024eb88&scoped=true&"
import script from "./hebiaojiageshenqing.vue?vue&type=script&lang=js&"
export * from "./hebiaojiageshenqing.vue?vue&type=script&lang=js&"
import style0 from "./hebiaojiageshenqing.vue?vue&type=style&index=0&id=5024eb88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5024eb88",
  null
  
)

export default component.exports